import ClearIcon from '@mui/icons-material/Clear'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {COMMON_FILTERS_WIDGET_NAMESPACE} from '../consts'

import {FilterActionButton} from './FilterActionButton'

type RemoveFilterProps = {
  removeFilter?: (keyName: string) => void
  keyName: string
  label?: string
}

export const RemoveFilterButton: React.FC<RemoveFilterProps> = ({removeFilter, keyName, label}) => {
  const {t} = useTranslation(COMMON_FILTERS_WIDGET_NAMESPACE)
  const displayLabel = label ?? t('label.removeFilter')
  return (
    <FilterActionButton
      sx={{
        margin: '10px 0'
      }}
      variant="text"
      onClick={() => removeFilter?.(keyName)}
      startIcon={<ClearIcon />}
      data-test-id={`remove-filter-button-${keyName}`}
    >
      {displayLabel}
    </FilterActionButton>
  )
}
